class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// class HeaderMenu extends DetailsDisclosure {
//   constructor() {
//     super();
//     this.isTouch = window.matchMedia('(hover: none)').matches;
//     this.header = document.querySelector('.header-wrapper');
//     this.menus = document.querySelectorAll('header-menu');
//     this.menus.forEach( menu => {
//       if (!this.isTouch) {
//         menu.addEventListener('mouseenter', (e) => this.open(e));
//         menu.addEventListener('mouseleave', () => this.closeAll());
//       }
//     })

//   }
//   open(e) {
//     this.closeAll();
//     const { target } = e;
//     target.querySelector('details').setAttribute('open', '');
//   }
//   closeAll() {
//     this.menus.forEach( menu => {
//       menu.querySelector('details').removeAttribute('open');
//     })
//   }
//   onToggle() {
//     if (!this.header) return;
//     this.header.preventHide = this.mainDetailsToggle.open;

//     if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
//     document.documentElement.style.setProperty(
//       '--header-bottom-position-desktop',
//       `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
//     );
//   }
// }

// customElements.define('header-menu', HeaderMenu);
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
    this.menus = document.querySelectorAll('header-menu');

    this.mql = window.matchMedia('(hover: none)');
    this.isTouch = this.mql.matches;

    this.setupEvents();

    this.mql.addEventListener('change', e => {
      this.isTouch = e.matches;
      this.resetEvents();
      this.setupEvents();
    });
  }

  setupEvents() {
    this.menus.forEach(menu => {
      if (!this.isTouch) {
        menu._onEnter = e => this.open(e);
        menu._onLeave = () => this.closeAll();

        menu.addEventListener('mouseenter', menu._onEnter);
        menu.addEventListener('mouseleave', menu._onLeave);
      }
    });
  }

  resetEvents() {
    this.menus.forEach(menu => {
      if (menu._onEnter) {
        menu.removeEventListener('mouseenter', menu._onEnter);
        menu.removeEventListener('mouseleave', menu._onLeave);
      }
    });
  }

  open(e) {
    this.closeAll();
    const details = e.currentTarget.querySelector('details');
    details?.setAttribute('open', '');
  }

  closeAll() {
    this.menus.forEach(menu => {
      menu.querySelector('details')?.removeAttribute('open');
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
